import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { EditAdminRequest } from '.././client-sdk/api';

export const useSubadminProfileApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


   const editSubadminProfile = useCallback(
    async (id: string, data: EditAdminRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.editSubAdmin(id, data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
    editSubadminProfile,   
    loading,
    error, 
  };
};
